export default {
  namespaced: true,
  state: {
    currentUser: JSON.parse(localStorage.getItem("currentUser")),
    storedUsers: JSON.parse(localStorage.getItem("storedUsers")) || [],
    sessionDetails: {},
    editor: null,
    cachedSessions: JSON.parse(localStorage.getItem("cachedSessions")) || [],
    ttsVoiceBySession: JSON.parse(localStorage.getItem("ttsVoiceBySession")) || {},
  },

  mutations: {
    updateCurrentUser(state, attributes) {
      state.currentUser = { ...state.currentUser, ...attributes };
      if (state.editor) {
        state.editor.chain().user(state.currentUser).run();
      }
      localStorage.setItem("currentUser", JSON.stringify(state.currentUser));
      this.commit("user/updateStoredUsers", state.currentUser);
    },

    updateStoredUsers(state, user) {
      let found = false;
      const newArr = state.storedUsers.map((userIn) => {
        if(user) {
          if (user.uid === state.currentUser.uid) {
            found = true;
            return { ...user, ...state.currentUser };
          }
          return userIn;
        }
      });
      if (!found && user !== null) {
        state.storedUsers.push(user);
      } else {
        state.storedUsers = newArr;
      }
      localStorage.setItem("storedUsers", JSON.stringify(state.storedUsers));
    },

    cleanupStoredUsers(state) {
      const newArr = state.storedUsers.filter((user) => {
        return user != null;
      })
      state.storedUsers = newArr;
      localStorage.setItem("storedUsers", JSON.stringify(state.storedUsers));
    },

    setCurrentUser(state, user) {
      state.currentUser = user;
      localStorage.setItem("currentUser", JSON.stringify(user));
    },

    setEditor(state, editor) {
      state.editor = editor;
    },

    destroyEditor(state) {
      state.editor.destroy();
    },

    setPlatform(state, platform) {
      state.platform = platform;
    },

    setSessionDetails(state, sessionDetails) {
      state.sessionDetails = sessionDetails;
    },

    addCachedSession(state, cachedSession) {
      state.cachedSessions.push(cachedSession)
      localStorage.setItem("cachedSessions", JSON.stringify(state.cachedSessions))
    },

    removeCachedSession(state, sessionId) {
      state.cachedSessions = state.cachedSessions.filter(function(item) {
        return item.localSessionId !== sessionId
      })
      localStorage.setItem("cachedSessions", JSON.stringify(state.cachedSessions))
    },

    updateCachedSession(state, payload) {
      const cachedSession = state.cachedSessions.find((item) => item.localessionId === payload.sessionId)

      const otherCachedSessions = state.cachedSessions.filter(function(item) {
        return item.localSessionId !== payload.sessionId
      })

      const updatedCachedSession = {
        ...cachedSession,
        ...payload.patch
      }

      state.cachedSessions = [
        ...otherCachedSessions,
        updatedCachedSession
      ]

      localStorage.setItem("cachedSessions", JSON.stringify(state.cachedSessions))
    },

    completedCachedUploadPart(state, payload) {
      const cachedSession = state.cachedSessions.find((item) => item.localSessionId === payload.sessionId)

      const otherCachedSessions = state.cachedSessions.filter(function(item) {
        return item.localSessionId !== payload.sessionId
      })

      cachedSession.parts[payload.partNumber - 1].eTag = payload.eTag
      cachedSession.parts[payload.partNumber - 1].completed = true

      console.log(cachedSession)

      state.cachedSessions = [
        ...otherCachedSessions,
        cachedSession
      ]

      localStorage.setItem("cachedSessions", JSON.stringify(state.cachedSessions))
    },

    //Cached sessions could occasionally be created without the requisite information to correctly
    //process and upload them. Primarily - they would be missing the 'currentStep' field.
    //This lets us remove those broken sessions from our session cache.
    removeCorruptedCachedSessions(state) {
      if(state.cachedSessions) {
        const validCachedSessions = state.cachedSessions.filter(function(item) {
          if('currentStep' in item) {
            return true
          } else {
            return false
          }
        })

        state.cachedSessions = validCachedSessions

        localStorage.setItem("cachedSessions", JSON.stringify(state.cachedSessions))
      }
    },

    setTTSVoiceBySession(state, payload) {
      state.ttsVoiceBySession[payload.sessionId] = payload.voiceId
      localStorage.setItem("ttsVoiceBySession", JSON.stringify(state.ttsVoiceBySession))
    },
  },
  actions: {},
  getters: {
    storedUserByEmail: (state) => (email) => {
      return state.storedUsers.find((user) => user.email === email);
    },

    currentUserSubscriptionActive: (state) => () => {
      return state.currentUser.self.subscription
        ? state.currentUser.self.subscription.status.includes("active") ||
            state.currentUser.self.subscription.status.includes("trialing")
        : false;
    },

    currentUserSubscriptionExpired: (state) => () => {
      if (
        state.currentUser.self.subscription &&
        state.currentUser.self.subscription.status
      ) {
        if (
          !state.currentUser.self.subscription.status.includes("active") &&
          !state.currentUser.self.subscription.status.includes("trialing")
        ) {
          // Assume if status exists and it's not active then it's expired
          return true;
        }
      }
      return false;
    },

    isCurrentUserSubscriptionCancellling: (state) => () => {
      if (
        state.currentUser.self.subscription &&
        state.currentUser.self.subscription.status
      ) {
        return state.currentUser.self.subscription.status.includes(
          "cancelling"
        );
      }
      return false;
    },

    isCurrentUserSubscriptionTrial: (state) => () => {
      if (
        state.currentUser.self.subscription &&
        state.currentUser.self.subscription.status
      ) {
        return state.currentUser.self.subscription.status.includes("trialing");
      }
      return false;
    },

    isCurrentUserSubscriptionMonthly: (state) => () => {
      if (
        state.currentUser.self.subscription &&
        state.currentUser.self.subscription.status
      ) {
        return state.currentUser.self.subscription.status.includes("active");
      }
      return false;
    },

    isCurrentUserSubscriptionStripe: (state) => () => {
      return state.currentUser.self.subscription.provider === "stripe";
    },

    isCurrentUserSubscriptionAppStore: (state) => () => {
      return state.currentUser.self.subscription.provider === "app-store";
    },

    cachedSessions: (state) => {
      const items = [...state.cachedSessions].sort((a,b) => {
        if(a['createdAt'] > b['createdAt']){return -1}
        if(a['createdAt'] < b['createdAt']){return 1}
        return 0
      })

      return items
    },

    cachedSessionByLocalSessionId: (state) => (localSessionId) => {
      return state.cachedSessions.find((cachedSession) => cachedSession.localSessionId == localSessionId);
    },

    cachedSessionByLocalFilePath: (state) => (filePath) => {
      return state.cachedSessions.find((cachedSession) => cachedSession.recordingCachePath == filePath);
    },

    hasProNotesEnabled: (state) => {
      //always show the "request pro notes" button to personal users
      if (state.currentUser.type !== 'Org User') return true
      // check if object is empty
      if (
        state.currentUser.self.meta.habitatAdmin.services &&
        typeof state.currentUser.self.meta.habitatAdmin.services === "object" &&
        !Array.isArray(state.currentUser.self.meta.habitatAdmin.services)
      )
      {
          // show "request pro notes" button to anyone with the service enabled
          const services = state.currentUser.self.meta.habitatAdmin.services.summary_notes
          if (services &&services.enabled === 1) return true
      }
      // hide it from everyone else
      return false
    }
  },
}